import { Component, OnInit } from '@angular/core';
import { CartService } from 'src/app/core/services/cart.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private cartService:CartService) { }

  ngOnInit() {
  }

  getTotal():number{
    return this.cartService.getTotal();
  }

}
